'use client';

import {publishEvent, TrackImpression} from '@udemy-v2/event-tracking';
import {useFormatDate, useI18n} from '@udemy-v2/i18n';
import {AlertBanner} from '@udemy-v2/react-notice-components';

import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {CourseRetirementBannerImpressionEvent} from '@/features/course-landing-page/events/events';
import {useCourseRetirement} from '@/features/course-landing-page/hooks/use-course-retirement';

import styles from './course-retirement-banner.module.scss';

export const CourseRetirementBanner = () => {
    const {gettext, interpolate} = useI18n();
    const {toLocaleDateString} = useFormatDate();
    const course = useClpCourse();
    const {retiresOn} = useCourseRetirement(course.id);

    if (!retiresOn) {
        return null;
    }

    const formattedRetirementDate = toLocaleDateString(new Date(retiresOn), {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const title = interpolate(
        gettext(
            'This course is set to be retired from your organization’s content collection on %(retirementDate)s.',
        ),
        {retirementDate: formattedRetirementDate},
        true,
    );

    const handleImpression = () => {
        publishEvent(
            new CourseRetirementBannerImpressionEvent({
                courseId: Number(course.id),
                courseTrackingId: course.frontendTrackingId ?? '',
            }),
        );
    };

    return (
        <TrackImpression trackFunc={handleImpression} testId="course-retirement-banner-impression">
            <AlertBanner
                className={styles.container}
                data-testid="course-retirement-banner"
                udStyle="warning"
                title={title}
                showCta={false}
                body={
                    <p>
                        {gettext(
                            "We're always updating our content collection to keep it fresh but enrolled learners won't lose access to this course.",
                        )}
                    </p>
                }
            />
        </TrackImpression>
    );
};
